import { defineStore } from 'pinia';
import { menuData } from '../menuData';

// AuthStore
export const DialogStore = defineStore({
    id: 'DialogState',
    state: () => ({
        alertOption: {
            open: false,
            message: '',
            buttonText: '',
            callback: () => {},
        },
        confirmOption: {
            open: false,
            message: '',
            ok: '',
            cancel: '',
            callback: () => {},
        },
        visibleModal: false,
    }),
    getters: {
        menuListGet: (state) => state.menuList,
    },
    actions: {
        // getAuthMenuList
        openAlertDialog(value) {
            this.alertOption = {
                open: true,
                message: value.message,
                buttonText: value.buttonText,
                callback: value?.callback ? value?.callback : null,
            };
            // console.log('[Vuex] openAlertDialog ===', this.alertOption);
        },
        closeAlertDialog(value) {
            this.alertOption = {
                open: false,
                message: '',
                buttonText: '',
                callback: this.alertOption?.callback ? this.alertOption?.callback(value) : null,
            };
            // console.log('[Vuex] closeAlertDialog ===', this.alertOption);
        },
        openConfirmDialog(value) {
            this.confirmOption = {
                open: true,
                message: value.message,
                cancel: value.cancel,
                ok: value.ok,
                callback: value?.callback ? value?.callback : null,
            };
            // console.log('[Vuex] openConfirmDialog ===', this.confirmOption);
        },
        closeConfirmDialog(value) {
            this.confirmOption = {
                open: false,
                message: '',
                cancel: '',
                ok: '',
                callback: this.confirmOption.callback ? this.confirmOption.callback(value) : null,
            };
            // console.log('[Vuex] closeConfirmDialog ===', this.confirmOption);
        },
        openModal(value) {
            this.visibleModal = value;
        },

        ///////공통_분기/////////
        openMsg(msg, callback) {
            this.alertOption = {
                open: true,
                message: msg,
                buttonText: '확인',
                callback: callback,
            };
        },
        openSelect(msg, callback) {
            this.confirmOption = {
                open: true,
                message: msg,
                cancel: '닫기',
                ok: '확인',
                callback: callback,
            };
        },
        errorMsg(msg, callback) {
            this.alertOption = {
                open: true,
                message: msg,
                buttonText: '확인',
                callback: callback,
            };
        },
        errorConnection(callback) {
            this.alertOption = {
                open: true,
                message: '통신 오류 : 재접속해 주세요.',
                buttonText: '확인',
                callback: callback,
            };
        },
    },
});
